module.exports = __webpack_public_path__ + "media/images/benefits_noexpire_active-e6dcf5d8.svg";